import { render, staticRenderFns } from "./DashboardMyStoryboards.vue?vue&type=template&id=83c83f4a&scoped=true&"
import script from "./DashboardMyStoryboards.vue?vue&type=script&lang=js&"
export * from "./DashboardMyStoryboards.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMyStoryboards.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DashboardMyStoryboards.vue?vue&type=style&index=1&id=83c83f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c83f4a",
  null
  
)

export default component.exports